import "core-js/stable";
import "regenerator-runtime/runtime";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import React from "react";
import ReactDOM from "react-dom";
import RegistrationFormContainer from "./containers/RegistrationFormContainer";
import "./i18n";

import "../style.scss";

const reCaptchaSiteKey = "6Lco12kpAAAAAIOfuVldcvjxdr5At2L51NoDofaT"; // Doesn't have to be secret, like a public key

export default function App() {
  return (
    <GoogleReCaptchaProvider reCaptchaKey={reCaptchaSiteKey} useEnterprise={true}>
      <RegistrationFormContainer />;
    </GoogleReCaptchaProvider>
  );
}

ReactDOM.render(<App />, document.getElementById("root"));
